const mobileProductsInit = () => {
  const mobileProductsMenu = document.querySelector('.products-menu-mobile') as HTMLElement;
  const mobileProductsLinks = mobileProductsMenu.querySelectorAll('.products-menu-mobile__inner-link') as NodeListOf<HTMLAnchorElement>;
  const mobileSubmenuClose = mobileProductsMenu.querySelectorAll('.products-menu-mobile__close--submenu') as NodeListOf<HTMLElement>;
  const mobileToggler = document.querySelectorAll('.menu-toggler') as NodeListOf<HTMLElement>;
  const mobileCloses = document.querySelectorAll('.products-menu-mobile__close--product') as NodeListOf<HTMLElement>;

  const toggleSubMenu = (subMenu: HTMLElement) => {
    subMenu.classList.toggle('products-menu-mobile__submenu--active');
  };

  const toggleMobileProductsMenu = () => {
    mobileProductsMenu.classList.toggle('products-menu-mobile--active');
  };

  [...mobileProductsLinks].forEach((link) => {
    link.addEventListener('click', (e: Event) => {
      const linkElement = link.nextSibling;
      const nextElement = linkElement.nextSibling as HTMLElement;

      if (nextElement && nextElement.classList.contains('products-menu-mobile__submenu')) {
        e.preventDefault();
        toggleSubMenu(nextElement);
      }
    });
  });

  [...mobileSubmenuClose].forEach((link) => {
    link.addEventListener('click', () => {
      const subMenu = link.closest('.products-menu-mobile__submenu') as HTMLElement;
      toggleSubMenu(subMenu);
    });
  });

  [...mobileToggler, ...mobileCloses].forEach((toggle) => {
    toggle.addEventListener('click', () => {
      if (window.outerWidth < 768) {
        toggleMobileProductsMenu();
      }
    });
  });
};

export default mobileProductsInit;
